import { OptionMenuItem } from "../../../../components/ui/OptionMenu"
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';

interface Props {
    onClick: () => void
}

export function UploadEmpresaFileButton({ onClick }: Props) {

    return (
        <OptionMenuItem onClick={onClick}>
            <FileUploadRoundedIcon sx={{ height: 20, width: 20 }}/>
            <p className="text-sm font-semibold text-center ">Subir excel</p>
        </OptionMenuItem>
    );
}
